/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicSpaceAvailabilityPathParameters } from 'api/actions/get-public-space-availability/get-public-space-availability-path-parameters';
import { GetPublicSpaceAvailabilityResponse } from 'api/actions/get-public-space-availability/get-public-space-availability-response';

type GetPublicSpaceAvailabilityQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicSpaceAvailability action.
 */
export const getPublicSpaceAvailabilityActionPath = new SweetPath<keyof GetPublicSpaceAvailabilityPathParameters>(
  '/reservations/public/spaces/{slug}/availability',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicSpaceAvailability actions.
 */
export default function createGetPublicSpaceAvailabilityAction(axios: AxiosInstance) {
  return function getPublicSpaceAvailabilityAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicSpaceAvailabilityPathParameters;
    query?: GetPublicSpaceAvailabilityQueryParameters;
  }) {
    const path = getPublicSpaceAvailabilityActionPath.insert(parameters);

    return axios.get<GetPublicSpaceAvailabilityResponse, GetPublicSpaceAvailabilityResponse>(path, {
      params: query,
      headers,
    });
  };
}
